import React, { Component } from 'react';
import { Route } from 'react-router';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';

import './custom.css'
import { AdminTaskForm } from './components/AdminTaskForm';
import { AdminTaskGrid } from './components/AdminTaskGrid';
import { AdminTaskDetail } from './components/Task/AdminTaskDetail';
import { Login } from './components/Login/Login';
import { RegistrationForm } from './components/RegistrationForm/RegistrationForm';
import { RegisteredUsers } from './components/Admin/RegisteredUsers/RegisteredUsers';
import { TermsAndConditions } from './components/TermsAndCondition/TermsAndConditions';
import { AdminProcess } from './components/Admin/Process/AdminProcess';
import { Financial } from './components/Admin/Financial/Financial';
import { User } from './components/User/User';
import { DetailBasic } from './components/DetailsProcess/Basic';
import { DetailAdvance } from './components/DetailsProcess/Advance';
import { DetailPl } from './components/DetailsProcess/Pl';
import { PQR } from './components/PQR/Pqr';
import { HistoryPaymentOnline } from './components/Admin/HistoryPaymentOnline/HistoryPaymentOnline';


import { HomeCommunity } from './components/Community/Home/Home';
import { LoginCommunity } from './components/Community/Login/Login';
import { Plan } from './components/Community/Plan/Plan'
import { PlanForm } from './components/Community/Plan/PlanForm';
    import { Layout } from './components/Layout';
import { PlanDetails } from './components/Community/Plan/PlanDetails';
import { PlanTopic } from './components/Community/Plan/PlanTopic';
import { RegisterCommunity } from './components/Community/Register/RegisterCommunity';
import { CommunityLife } from './components/Community/CommunityLife/CommunityLife';
import { AddProcess } from './components/Admin/Process/AddProcess';
import { AdminPlan } from './components/Community/Plan/AdminPlan';
import { Letter } from './components/Community/Letter/Letter';
import { Follow } from './components/Community/Letter/Follow';
import { MyProfile } from './components/Community/MyProfile/MyProfile';
import { SeniorityForm } from './components/Community/MyProfile/SeniorityForm';
import { DataPolicy } from './components/TermsAndCondition/DataPolicy';
import { OurTraining } from './components/OurTraining/OurTraning';
import { PqrAdmin } from './components/PQR/PqrAdmin';





export default class App extends Component {
    static displayName = App.name;

    render() {
            return (
                <Layout>
                    <Route exact path='/' component={Home} />
                    <Route path='/counter' component={Counter} />
                    <Route path='/fetch-data' component={FetchData} />
                    <Route path='/nueva-tarea' component={AdminTaskForm} />
                    <Route path='/tareas' component={AdminTaskGrid} exact />
                    <Route path='/tareas/detalle' component={AdminTaskDetail} />
                    <Route path='/iniciar-sesion' component={Login} />
                    <Route path='/registro' component={RegistrationForm} />
                    <Route path='/ficha-basico' component={RegistrationForm} />
                    <Route path='/ficha-avanzado' component={RegistrationForm} />
                    <Route path='/ficha-pl' component={RegistrationForm} />
                    <Route path='/usuarios-registrados' component={RegisteredUsers} />
                    <Route path="/terminos-y-condiciones" component={TermsAndConditions} />
                    <Route path="/politica-de-datos" component={DataPolicy} />
                    <Route path="/politicas-de-privacidad" component={TermsAndConditions} />
                    <Route exact path="/administrar-procesos" component={AdminProcess} />
                    <Route path="/administrar-procesos/proceso" component={AddProcess} />
                    <Route path="/financiero" component={Financial} />
                    <Route path="/usuario" component={User} />
                    <Route path="/proceso-basico" component={DetailBasic} />
                    <Route path="/proceso-avanzado" component={DetailAdvance} />
                    <Route path="/proceso-pl" component={DetailPl} />
                    <Route path="/pqr" component={PQR} />
                    <Route path="/nuestro-entrenamiento" component={OurTraining} />
                    <Route path="/historial-de-pagos" component={HistoryPaymentOnline} />
                    <Route path="/administrar-pqr" component={PqrAdmin} />
                    <Route exact exact path='/comunidad' component={HomeCommunity} />
                    <Route exact path='/comunidad/plan' component={Plan} />
                    <Route path='/comunidad/plan/form' component={PlanForm} />
                    <Route path="/comunidad/plan/detalle/" component={PlanDetails} />
                    <Route path="/comunidad/tema/" component={PlanTopic} />
                    <Route path="/comunidad/pls" component={CommunityLife} />
                    <Route path="/comunidad/plan/Administrar" component={AdminPlan} />
                    <Route path="/comunidad/carta-de-logro" component={Letter} />
                    <Route path="/comunidad/seguimiento" component={Follow} />
                    <Route exact path="/comunidad/mi-perfil" component={MyProfile} />
                    <Route path="/comunidad/mi-perfil/seniority" component={SeniorityForm} />
                </Layout>
            );
    }
}
